const data = [
  {
    class: "Class 1",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%201.jpg?alt=media&token=afe1e39f-efe5-40e9-b762-1d6c33584ae8",
    desc: "Maths , EVS",
    course_content: [
      {
        maths: [
          "Class 1 Math Chapters:",
          "Chapter 1  - Shapes and Space",
          "Chapter 2  - Numbers from One to Nine",
          "Chapter 3  - Addition",
          "Chapter 4  - Subtraction",
          "Chapter 5  - Numbers from Ten to Twenty",
          "Chapter 6  - Time",
          "Chapter 7  - Measurement",
          "Chapter 8  - Numbers from Twenty-one to Fifty",
          "Chapter 9  - Data Handling",
          "Chapter 10 -  Patterns",
          "Chapter 11 -  Numbers",
          "Chapter 12 -  Money",
          "Chapter 13 -  How Many",
        ],
        evs: [
          "Class 1 EVS ",
          "Chapter 1 - Weather and Seasons",
          "Chapter 2 - Food and Water",
          "Chapter 3 - Travel and Safety",
          "Chapter 4 - Human Body",
          "Chapter 5 - Plant Life",
          "Chapter 6 - Clothes",
          "Chapter 7 - My Family and School",
          "Chapter 8 - Family Tree",
          "Chapter 9 - Our festivals",
        ],
      },
    ],
  },
  {
    class: "Class 2",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%202.jpg?alt=media&token=fb4c568d-65fd-4d72-93da-cb1fc794e464",
    desc: "Maths , EVS",
    course_content: [
      {
        maths: [
          "CLASS 2 MATHS",
          "Chapter 1  - What is Long, What is Round?",
          "Chapter 2  - Counting in Groups",
          "Chapter 3  - How Much Can You Carry?",
          "Chapter 4  - Counting in Tens",
          "Chapter 5  - Patterns",
          "Chapter 6  - Footprints",
          "Chapter 7  - Jugs and Mugs",
          "Chapter 8  - Tens and Ones",
          "Chapter 9  - My Funday",
          "Chapter 10 -  Add our Points",
          "Chapter 11 -  Lines and Lines",
          "Chapter 12 -  Give and Take",
          "Chapter 13 -  The Longest Step",
          "Chapter 14 -  Birds Come, Birds Go",
          "Chapter 15 -  How Many Ponytails?",
        ],
        evs: [
          "Class 2 EVS ",
          "Chapter 1 - Invention of the Wheel",
          "Chapter 2 - Good Habits",
          "Chapter 3 - Means of Communication",
          "Chapter 4 - Clothes",
          "Chapter 5 - World Around Me",
          "Chapter 6 - Get To Know Me",
          "Chapter 7 - Understanding Directions",
          "Chapter 8 - Houses",
          "Chapter 9 - Services In Neighbourhood",
          "Chapter 10 - Time",
          "Chapter 11 - Air, Water, Food, Shelter",
          "Chapter 12 - Means of Transport",
          "Chapter 13 - Our Family",
        ],
      },
    ],
  },
  {
    class: "Class 3",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%203.jpg?alt=media&token=c9f9e31a-c365-4dc3-873a-2e9dd1c1771a",
    desc: "Maths , EVS",
    course_content: [
      {
        maths: [
          "CLASS 3 MATHS",
          "Chapter 1  - Where to look from?",
          "Chapter 2  - Fun with Numbers",
          "Chapter 3  - Give and Take",
          "Chapter 4  - Long and Short",
          "Chapter 5  - Shapes and Designs",
          "Chapter 6  - Fun with Give and Take",
          "Chapter 7  - Time Goes on",
          "Chapter 8  - Who is Heavier?",
          "Chapter 9  - How many times?",
          "Chapter 10 -  Play with Patterns",
          "Chapter 11 -  Jugs and Mugs",
          "Chapter 12 -  Can We Share?",
          "Chapter 13 -  Smart Charts",
          "Chapter 14 -  Rupees and Paise",
        ],
        evs: [
          "Class 3 EVS",
          "Chapter 1  - Poonam’s Day Out",
          "Chapter 2  - The Plant Fairy",
          "Chapter 3  - Water O’ Water!",
          "Chapter 4  - Our First School",
          "Chapter 5  - Chhotu’s House",
          "Chapter 6  - Foods We Eat",
          "Chapter 7  - Saying without Speaking",
          "Chapter 8  - Flying High",
          "Chapter 9  - It’s Raining",
          "Chapter 10 -  What is Cooking",
          "Chapter 11 -  From Here to There",
          "Chapter 12 -  Work We Do",
          "Chapter 13 -  Sharing Our Feelings",
          "Chapter 14 -  The Story of Food",
        ],
      },
    ],
  },
  {
    class: "Class 4",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%204.jpg?alt=media&token=2ef2a6a8-91f6-4b62-8c1c-c7851ebd257e",
    desc: "Maths , EVS",
    course_content: [
      {
        maths: [
          "Class 4 Maths",
          "Chapter 1  - Building With Bricks ",
          "Chapter 2  - Long And Short",
          "Chapter 3  - A Trip To Bhopal ",
          "Chapter 4  - Tick-tick-tick",
          "Chapter 5  - The Way The World Looks",
          "Chapter 6  - The Junk Seller",
          "Chapter 7  - Mugs And Mugs ",
          "Chapter 8  - Carts And Wheels",
          "Chapter 9  - Halves And Quarters ",
          "Chapter 10 -  Play With Patterns",
          "Chapter 11 -  Tables And Shares ",
          "Chapter 12 -  How Heavy? How Light?",
          "Chapter 13 -  Fields And Fences ",
          "Chapter 14 -  Smart Charts",
        ],
        evs: [
          "Class 4 EVS Chapters:",
          "Chapter 1 - Going To School.",
          "Chapter 2 - Ear To Ear.",
          "Chapter 3 - A Day With Nandu.",
          "Chapter 4 - The Story Of Amrita.",
          "Chapter 5 - Anita And The Honeybees.",
          "Chapter 6 - Omana Journey.",
          "Chapter 7 - From The Window.",
          "Chapter 8 - Reaching Grandmother House.",
          "Chapter 9 - Changing Families",
          "Chapter 10 - Hu Tu Tuhu Tu Tu",
          "Chapter 11 - The Valley Of Flowers",
          "Chapter 12 - Changing Times",
          "Chapter 13 - A Rivers Tale",
          "Chapter 14 - Basva Farm",
          "Chapter 15 - From Market To Home",
          "Chapter 16 - A Busy Month",
          "Chapter 17 - Nandita In Mumbai",
          "Chapter 18 - Too Much Water, Too Little Water",
          "Chapter 19 - Abdul In The Garden",
          "Chapter 20 - Eating Together",
          "Chapter 21 - Food And Fun",
          "Chapter 22 - The World In My Home",
          "Chapter 23 - Pochampalli",
          "Chapter 24 - Home And Abroad",
          "Chapter 25 - Spicy Riddles",
          "Chapter 26 - Defence Officer Wahida",
          "Chapter 27 - Chuskit Goes To School",
        ],
      },
    ],
  },
  {
    class: "Class 5",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%205.png?alt=media&token=7f64703f-84b2-4716-84a3-a6011b173bd2",
    desc: "Maths , EVS",
    course_content: [
      {
        maths: [
          "Class 5 Maths Chapters",
          "Chapter 1  - The Fish Tale ",
          "Chapter 2  - Shapes And Angles ",
          "Chapter 3  - How Many Squares? ",
          "Chapter 4  - Parts and Wholes ",
          "Chapter 5  - Does It Look The Same? ",
          "Chapter 6  - Be my Multiple, I’ll Be Your Factor ",
          "Chapter 7  - Can You See The Pattern? ",
          "Chapter 8  - Mapping Your Way",
          "Chapter 9  - Boxes And Sketches",
          "Chapter 10 -  Tenths And Hundredths",
          "Chapter 11 -  Areas And Its Boundary",
          "Chapter 12 -  Smart Charts",
          "Chapter 13 -  Ways To Multiply And Divide",
          "Chapter 14 -  How Big? How Heavy?",
        ],
        evs: [
          "Class 5 EVS Chapters:",
          "Chapter 1 - The Super Senses",
          "Chapter 2 - A Snake Charmer Story",
          "Chapter 3 - From Tasting To Digesting",
          "Chapter 4 - Mangoes Round The Year",
          "Chapter 5 - Seeds And Seeds",
          "Chapter 6 - Every Drop Counts",
          "Chapter 7 - Experiments With Water",
          "Chapter 8 - A Treat For Mosquitoes",
          "Chapter 9 - Up You Go",
          "Chapter 10 - Walls Tell Stories",
          "Chapter 11 - Sunita In Space",
          "Chapter 12 - What If It Finishes",
          "Chapter 13 - A Shelter So High",
          "Chapter 14 - When The Earth Shook",
          "Chapter 15 - Blow Hot, Blow Cold",
          "Chapter 16 - Who Will Do This Work",
          "Chapter 17 - Across The Wall",
          "Chapter 18 - No Place For Us",
          "Chapter 19 - A Seed Tells A Farmer Story",
          "Chapter 20 - Whose Forests",
          "Chapter 21 - Like Father, Like Daughter",
          "Chapter 22 - On The Move Again",
        ],
      },
    ],
  },
  {
    class: "Class 6",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%206.png?alt=media&token=51467771-5b8a-46b3-a424-d3b15b4b0e89",
    desc: "Maths , Science",
    course_content: [
      {
        maths: [
          "CLASS 6 MATHS",
          "Chapter 1  - Knowing Our Numbers",
          "Chapter 2  - Whole Numbers",
          "Chapter 3  - Playing with Numbers",
          "Chapter 4  - Basic Geometrical Ideas",
          "Chapter 5  - Understanding Elementary Shapes",
          "Chapter 6  - Integers",
          "Chapter 7  - Fractions",
          "Chapter 8  - Decimals",
          "Chapter 9  - Data Handling",
          "Chapter 10 -  Mensuration",
          "Chapter 11 -  Algebra",
          "Chapter 12 -  Ratio and Proportion",
          "Chapter 13 -  Symmetry",
          "Chapter 14 -  Practical Geometry",
        ],
        science: [
          "Class 6 Science Chapters:",
          "Chapter 1 - Food - Where Does It Come From",
          "Chapter 2 - Components of Food",
          "Chapter 3 - Fibre to Fabric",
          "Chapter 4 - Sorting Materials Into Groups",
          "Chapter 5 - Separation of Substances",
          "Chapter 6 - Changes Around Us",
          "Chapter 7 - Getting to Know Plants",
          "Chapter 8 - Body Movements",
          "Chapter 9 - The Living Organisms and Their Surroundings",
          "Chapter 10 - Motion and Measurement of Distances",
          "Chapter 11 - Light, Shadows and Reflection",
          "Chapter 12 - Electricity and Circuits",
          "Chapter 13 - Fun with Magnets",
          "Chapter 14 - Water",
          "Chapter 15 - Air Around Us",
          "Chapter 16 - Garbage In, Garbage Out",
        ],
      },
    ],
  },
  {
    class: "Class 7",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%207.png?alt=media&token=002236f1-c54e-4ab0-a0c9-56b4ad90604d",
    desc: "Maths , Science",
    course_content: [
      {
        maths: [
          "Class 7 Maths",
          "Chapter 1  - Integers",
          "Chapter 2  - Fractions and Decimals",
          "Chapter 3  - Data Handling",
          "Chapter 4  - Simple Equations",
          "Chapter 5  - Lines and Angles",
          "Chapter 6  - The Triangle and its Properties",
          "Chapter 7  - Congruence of Triangles",
          "Chapter 8  - Comparing Quantities",
          "Chapter 9  - Rational Numbers",
          "Chapter 10 -  Practical Geometry",
          "Chapter 11 -  Perimeter and Area",
          "Chapter 12 -  Algebraic Expressions",
          "Chapter 13 -  Exponents and Powers",
          "Chapter 14 -  Symmetry",
          "Chapter 15 -  Visualising Solid Shapes",
        ],
        science: [
          "Class 7 Science Chapters:",
          "Chapter 1 - Nutrition in Plants",
          "Chapter 2 - Nutrition in Animals",
          "Chapter 3 - Fibre to Fabric",
          "Chapter 4 - Heat",
          "Chapter 5 - Acids, Bases and Salts",
          "Chapter 6 - Physical and Chemical Changes",
          "Chapter 7 - Weather, Climate and Adaptations of Animals to Climate",
          "Chapter 8 - Winds, Storms and Cyclones",
          "Chapter 9 - Soil",
          "Chapter 10 - Respiration in Organisms",
          "Chapter 11 - Transportation in Animals and Plants",
          "Chapter 12 - Reproduction in Plants",
          "Chapter 13 - Motion and Time",
          "Chapter 14 - Electric Current and its Effects",
          "Chapter 15 - Light",
          "Chapter 16 - Water: A Precious Resource",
          "Chapter 17 - Forests: Our Lifeline",
          "Chapter 18 - Wastewater Story",
        ],
      },
    ],
  },
  {
    class: "Class 8",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%208.png?alt=media&token=8f62f235-5381-4d9a-be44-6448c06da412",
    desc: "Maths , Science",
    course_content: [
      {
        maths: [
          "Class 8 MATHS",
          "Chapter 1  - Rational Numbers",
          "Chapter 2  - Linear Equations in One Variable",
          "Chapter 3  - Understanding Quadrilaterals",
          "Chapter 4  - Practical Geometry",
          "Chapter 5  - Data Handling",
          "Chapter 6  - Squares and Square Roots",
          "Chapter 7  - Cubes and Cube Roots",
          "Chapter 8  - Comparing Quantities",
          "Chapter 9  - Algebraic Expressions and Identities",
          "Chapter 10 -  Visualising Solid Shapes",
          "Chapter 11 -  Mensuration",
          "Chapter 12 -  Exponents and Powers",
          "Chapter 13 -  Direct and Inverse Proportions",
          "Chapter 14 -  Factorisation",
          "Chapter 15 -  Introduction to Graphs",
          "Chapter 16 -  Playing with Numbers",
        ],
        science: [
          "Class 8 Science Chapters:",
          "Chapter 1 - Crop Production and Management",
          "Chapter 2 - Microorganisms : Friend and Foe",
          "Chapter 3 - Synthetic Fibres and Plastics",
          "Chapter 4 - Materials : Metals and Non-Metals",
          "Chapter 5 - Coal and Petroleum",
          "Chapter 6 - Combustion and Flame",
          "Chapter 7 - Conservation of Plants and Animals",
          "Chapter 8 - Cell - Structure and Functions",
          "Chapter 9 - Reproduction in Animals",
          "Chapter 10 - Reaching the Age of Adolescence",
          "Chapter 11 - Force and Pressure",
          "Chapter 12 - Friction",
          "Chapter 13 - Sound",
          "Chapter 14 - Chemical Effects of Electric Current",
          "Chapter 15 - Some Natural Phenomena",
          "Chapter 16 - Light",
          "Chapter 17 - Stars and the Solar System",
          "Chapter 18 - Pollution of Air and Water",
        ],
      },
    ],
  },
  {
    class: "Class 9",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%209.png?alt=media&token=049d5c96-eecc-4eb3-b4db-6a6bcc63b979",
    desc: "Maths , Science",
    course_content: [
      {
        maths: [
          "Class 9 Maths Chapters",
          "Chapter 1  - Number System",
          "Chapter 2  - Polynomials",
          "Chapter 3  - Coordinate Geometry",
          "Chapter 4  - Linear Equations in Two Variables",
          "Chapter 5  - Introduction to Euclids Geometry",
          "Chapter 6  - Lines and Angles",
          "Chapter 7  - Triangles",
          "Chapter 8  - Quadrilaterals",
          "Chapter 9  - Areas of Parallelograms and Triangles",
          "Chapter 10 -  Circles",
          "Chapter 11 -  Constructions",
          "Chapter 12 -  Heron’s Formula",
          "Chapter 13 -  Surface Areas and Volumes",
          "Chapter 14 -  Statistics",
          "Chapter 15 -  Probability",
        ],
        science: [
          "Class 9 Science Chapters:",
          "Chapter 1 - Matter in Our Surroundings",
          "Chapter 2 - Is Matter Around Us Pure",
          "Chapter 3 - Atoms and Molecules",
          "Chapter 4 - Structure of the Atom",
          "Chapter 5 - The Fundamental Unit of Life",
          "Chapter 6 - Tissues",
          "Chapter 7 - Diversity in Living Organisms",
          "Chapter 8 - Motion",
          "Chapter 9 - Force and Laws of Motion",
          "Chapter 10 - Gravitation",
          "Chapter 11 - Work and Energy",
          "Chapter 12 - Sound",
          "Chapter 13 - Why Do We Fall Ill",
          "Chapter 14 - Natural Resources",
          "Chapter 15 - Improvement in Food Resources",
        ],
      },
    ],
  },
  {
    class: "Class 10",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%2010.png?alt=media&token=2a0ebcdb-baa3-4010-83b4-56324ed3d7a1",
    desc: "Maths , Science",
    course_content: [
      {
        maths: [
          "Class 10 Maths Chapters",
          "Chapter 1  - Real Numbers",
          "Chapter 2  - Polynomials",
          "Chapter 3  - Pair of Linear Equations in Two Variables",
          "Chapter 4  - Quadratic Equations",
          "Chapter 5  - Arithmetic Progressions",
          "Chapter 6  - Triangles",
          "Chapter 7  - Coordinate Geometry",
          "Chapter 8  - Introduction to Trigonometry",
          "Chapter 9  - Some Applications of Trigonometry",
          "Chapter 10 -  Circles",
          "Chapter 11 -  Constructions",
          "Chapter 12 -  Areas Related to Circles",
          "Chapter 13 -  Surface Areas and Volumes",
          "Chapter 14 -  Statistics",
          "Chapter 15 -  Probability",
        ],
        science: [
          "Class 10 Science Chapters:",
          "Chapter 1 - Chemical Reactions and Equations",
          "Chapter 2 - Acids, Bases and Salts",
          "Chapter 3 - Metals and Non-metals",
          "Chapter 4 - Carbon and its Compounds",
          "Chapter 5 - Periodic Classification of Elements",
          "Chapter 6 - Life Processes",
          "Chapter 7 - Control and Coordination",
          "Chapter 8 - How do Organisms Reproduce",
          "Chapter 9 - Heredity and Evolution",
          "Chapter 10 - Light - Reflection and Refraction",
          "Chapter 11 - Human Eye and Colourful World",
          "Chapter 12 - Electricity",
          "Chapter 13 - Magnetic Effects of Electric Current",
          "Chapter 14 - Sources of Energy",
          "Chapter 15 - Our Environment",
          "Chapter 16 - Management of Natural Resources",
        ],
      },
    ],
  },
  {
    class: "Class 11",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%2011.png?alt=media&token=7ee53c16-ce7e-430e-9636-b30e663e4405",
    desc: "Maths ,Biology, Chemistry, Physics",
    course_content: [
      {
        maths: [
          "Class 11 Maths Chapters",
          "Chapter 1  - Sets",
          "Chapter 2  - Relations and Functions",
          "Chapter 3  - Trigonometric Functions",
          "Chapter 4  - Principle of Mathematical Induction",
          "Chapter 5  - Complex Numbers and Quadratic Equations",
          "Chapter 6  - Linear Inequalities",
          "Chapter 7  - Permutations and Combinations",
          "Chapter 8  - Binomial Theorem",
          "Chapter 9  - Sequences and Series",
          "Chapter 10 -  Straight lines",
          "Chapter 11 -  Conic Sections",
          "Chapter 12 -  Introduction to Three Dimensional Geometry",
          "Chapter 13 -  Limits and Derivatives",
          "Chapter 14 -  Mathematical Reasoning",
          "Chapter 15 -  Statistics",
          "Chapter 16 -  Probability",
        ],
        physics: [
          "Class 11 Physics - Physics Part I",
          "Chapter 1 - Units And Measurements",
          "Chapter 2 - Motion in a Straight Line",
          "Chapter 3 - Motion in a Plane",
          "Chapter 4 - Laws of Motion",
          "Chapter 5 - Work, Energy And Power",
          "Chapter 6 - System Of Particles And Rotational Motion",
          "Chapter 7 - Gravitation",
          "Class 11 Physics - Physics Part II",
          "Chapter 1 - Mechanical Properties Of Solids",
          "Chapter 2 - Mechanical Properties Of Fluids",
          "Chapter 3 - Thermal Properties Of Matter",
          "Chapter 4 - Thermodynamics",
          "Chapter 5 - Kinetic Theory",
          "Chapter 6 - Oscillations",
          "Chapter 7 - Waves",
        ],
        biology: [
          "Class 11 Biology Chapters:",
          "Chapter 1 - The Living World",
          "Chapter 2 - Biological Classification",
          "Chapter 3 - Plant Kingdom",
          "Chapter 4 - Animal Kingdom",
          "Chapter 5 - Morphology of Flowering Plants",
          "Chapter 6 - Anatomy of Flowering Plants",
          "Chapter 7 - Structural Organisation in Animals",
          "Chapter 8 - Cell: The Unit of Life",
          "Chapter 9 - Biomolecules",
          "Chapter 10 - Cell Cycle and Cell Division",
          "Chapter 11 - Transport in Plants",
          "Chapter 12 - Mineral Nutrition",
          "Chapter 13 - Photosynthesis in Higher Plants",
          "Chapter 14 - Respiration in Plants",
          "Chapter 15 - Plant Growth and Development",
          "Chapter 16 - Digestion and Absorption",
          "Chapter 17 - Breathing and Exchange of Gases",
          "Chapter 18 - Body Fluids and Circulation",
          "Chapter 19 - Excretory Products and their Elimination",
          "Chapter 20 - Locomotion and Movement",
          "Chapter 21 - Neural Control and Coordination",
          "Chapter 22 - Chemical Coordination and Integration",
        ],
        chemistry: [
          "Class 11 Chemistry - Chemistry Part I",
          "Chapter 1 - Some Basic Concepts of Chemistry",
          "Chapter 2 - Structure of Atom",
          "Chapter 3 - Classification of Elements and Periodicity in Properties",
          "Chapter 4 - Chemical Bonding and Molecular Structure",
          "Chapter 5 - States of Matter",
          "Chapter 6 - Chemical Thermodynamics",
          "Chapter 7 - Equilibrium",
          "Class 11 Chemistry - Chemistry Part II",
          "Chapter 1 - Redox Reactions",
          "Chapter 2 - Hydrogen",
          "Chapter 3 - The s-Block Elements",
          "Chapter 4 - The p-Block Elements",
          "Chapter 5 - Organic Chemistry: Some Basic Principles and Techniques",
          "Chapter 6 - Hydrocarbons",
          "Chapter 7 - Environmental Chemistry",
        ],
      },
    ],
  },
  {
    class: "Class 12",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/career-grads.appspot.com/o/School%20Course%20Images%2Fclass%2012.png?alt=media&token=2a5163cb-1d9a-4a3a-9d43-3ea2aba6abd5",
    desc: "Maths , Chemistry, Biology, Physics",
    course_content: [
      {
        maths: [
          "Class 12 Maths",
          "Chapter 1  - Relations and Functions",
          "Chapter 2  - Inverse Trigonometric Functions",
          "Chapter 3  - Matrices",
          "Chapter 4  - Determinants",
          "Chapter 5  - Continuity and Differentiability",
          "Chapter 6  - Applications of Derivatives",
          "Chapter 7  - Integrals",
          "Chapter 8  - Applications of Integrals",
          "Chapter 9  - Differential Equations",
          "Chapter 10 -  Vector Algebra",
          "Chapter 11 -  Three dimensional Geometry",
          "Chapter 12 -  Linear Programming",
          "Chapter 13 -  Probability",
        ],
        biology: [
          "Class 12 Biology Chapters:",
          "Chapter 1 - Reproduction in Organisms",
          "Chapter 2 - Sexual Reproduction in Flowering Plants",
          "Chapter 3 - Human Reproduction",
          "Chapter 4 - Reproductive Health",
          "Chapter 5 - Principles of Inheritance and Variation",
          "Chapter 6 - Molecular Basis of Inheritance",
          "Chapter 7 - Evolution",
          "Chapter 8 - Human Health and Disease",
          "Chapter 9 - Strategies for Enhancement in Food Production",
          "Chapter 10 - Microbes in Human Welfare",
          "Chapter 11 - Biotechnology: Principles and Processes",
          "Chapter 12 - Biotechnology and its Applications",
          "Chapter 13 - Organisms and Populations",
          "Chapter 14 - Ecosystem",
          "Chapter 15 - Biodiversity and Conservation",
          "Chapter 16 - Environmental Issues",
        ],
        chemistry: [
          "Class 12 Chemistry - Chemistry Part I",
          "Chapter 1 - The Solid State",
          "Chapter 2 - Solutions",
          "Chapter 3 - Electrochemistry",
          "Chapter 4 - Chemical Kinetics",
          "Chapter 5 - Surface Chemistry",
          "Chapter 6 - General Principles and Processes of Isolation of Elements",
          "Chapter 7 - The p-Block Elements",
          "Chapter 8 - The d-and f-Block Elements",
          "Chapter 9 - Coordination Compounds",
          "Class 12 Chemistry - Chemistry Part II",
          "Chapter 1 - Haloalkanes and Haloarenes",
          "Chapter 2 - Alcohols, Phenols and Ethers",
          "Chapter 3 - Aldehydes Ketones and Carboxylic Acids",
          "Chapter 4 - Amines",
          "Chapter 5 - Biomolecules",
          "Chapter 6 - Polymers",
          "Chapter 7 - Chemistry in Everyday Life",
        ],
        physics: [
          "Class 12 Physics - Physics Part I",
          "Chapter 1 - Electric Charges And Fields",
          "Chapter 2 - Electrostatic Potential And Capacitance",
          "Chapter 3 - Current Electricity",
          "Chapter 4 - Moving Charges And Magnetism",
          "Chapter 5 - Magnetism And Matter",
          "Chapter 6 - Electromagnetic Induction",
          "Chapter 7 - Alternating Current",
          "Chapter 8 - Electromagnetic Waves",
          "Class 12 Physics - Physics Part II",
          "Chapter 1 - Ray Optics And Optical Instruments",
          "Chapter 2 - Wave Optics",
          "Chapter 3 - Dual Nature Of Radiation And Matter",
          "Chapter 4 - Atoms",
          "Chapter 5 - Nuclei",
          "Chapter 6 - Semiconductor Electronics: Materials Devices and Simple Circuits",
          "Chapter 7 - Communication Systems",
        ],
      },
    ],
  },
];
export default data;
